import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  InStoreInitialState,
  InStoreSetAgenciesList,
  InStoreSetAgencyError,
  InStoreSetAgencyInfo,
  InStoreSetAgencyLoader,
  SetInStoreColisNumberAndDescriptionAction,
  SetInStoreReceiverAction,
  SetInStoreSenderAction,
  SetInStoreSenderIsNotReceiverAction,
  SetInStoreSubmitDataSetErrorAction,
  SetInStoreSubmitDataSetLoaderAction,
  SetInStoreSubmitDataSetSuccessAction,
} from '../InStore.types';

const initialState: InStoreInitialState = {
  agency: {
    isLoading: false,
    info: null,
    error: null,
    agencies: [],
  },
  submitData: {
    isLoading: false,
    error: null,
    success: null,
  },
  form: {
    sender: {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      address: '',
    },
    receiver: {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      address: '',
    },
    senderIsNotReceiver: false,
    toAgency: '',
    colisNumber: 0,
    description: '',
  },
  marketingAgencyId: undefined,
};

export const InStoreSlicer = createSlice({
  name: 'InStore',
  initialState,
  reducers: {
    setInStoreAgencyLoader: (state, action: PayloadAction<InStoreSetAgencyLoader>) => {
      state.agency.isLoading = action.payload.isLoading;
    },
    setInStoreAgencyError: (state, action: PayloadAction<InStoreSetAgencyError>) => {
      state.agency.error = action.payload.error;
    },
    setInStoreAgencyInfo: (state, action: PayloadAction<InStoreSetAgencyInfo>) => {
      state.agency.info = action.payload.info;
    },
    setInStoreAgenciesList: (state, action: PayloadAction<InStoreSetAgenciesList>) => {
      state.agency.agencies = action.payload.agencies;
    },
    setInStoreSender: (state, action: PayloadAction<SetInStoreSenderAction>) => {
      state.form.sender = action.payload.sender;
      state.form.toAgency = action.payload.sender.toAgency;
    },
    setResetInStoreFormData: (state) => {
      state.form = initialState.form;
    },
    setInStoreReceiver: (state, action: PayloadAction<SetInStoreReceiverAction>) => {
      state.form.receiver = action.payload.receiver;
    },
    setInStoreSenderIsNotReceiver: (state, action: PayloadAction<SetInStoreSenderIsNotReceiverAction>) => {
      state.form.senderIsNotReceiver = action.payload.senderIsNotReceiver;
    },
    setInStoreColisNumberAndDescription: (state, action: PayloadAction<SetInStoreColisNumberAndDescriptionAction>) => {
      state.form.colisNumber = action.payload.colisNumber;
      state.form.description = action.payload.description;
    },
    setInStoreSubmitDataSetLoader: (state, action: PayloadAction<SetInStoreSubmitDataSetLoaderAction>) => {
      state.submitData.isLoading = action.payload.isLoading;
    },
    setInStoreSubmitDataSetError: (state, action: PayloadAction<SetInStoreSubmitDataSetErrorAction>) => {
      state.submitData.error = action.payload.error;
    },
    setInStoreSubmitDataSetSuccess: (state, action: PayloadAction<SetInStoreSubmitDataSetSuccessAction>) => {
      state.submitData.success = action.payload.success;
    },
    setInStoreIsFromAgencyMarketing: (state, action: PayloadAction<string | undefined>) => {
      state.marketingAgencyId = action.payload;
    },
  },
});

export const {
  setInStoreAgencyError,
  setInStoreAgencyInfo,
  setInStoreSender,
  setInStoreAgencyLoader,
  setInStoreAgenciesList,
  setInStoreSenderIsNotReceiver,
  setInStoreReceiver,
  setInStoreColisNumberAndDescription,
  setInStoreSubmitDataSetLoader,
  setInStoreSubmitDataSetError,
  setInStoreSubmitDataSetSuccess,
  setResetInStoreFormData,
  setInStoreIsFromAgencyMarketing,
} = InStoreSlicer.actions;

export const InStoreReducer = InStoreSlicer.reducer;
